import { Deficiency } from '@/api/models/Contracts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DeficiencyState {
  deficiencies: Deficiency[] | [];
  loading: boolean;
  error: string | null;
}

const initialState: DeficiencyState = {
  deficiencies: [],
  loading: false,
  error: null,
};

const deficiencySlice = createSlice({
  name: 'deficiencies',
  initialState,
  reducers: {
    fetchDeficiencyRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDeficiencySuccess: (state, action: PayloadAction<Deficiency[]>) => {
      state.loading = false;
      state.error = null;
      state.deficiencies = action.payload;
    },
    fetchDeficiencyFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchDeficiencyRequest, fetchDeficiencySuccess, fetchDeficiencyFailure } =
  deficiencySlice.actions;

export default deficiencySlice.reducer;
